import { AfterViewInit, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import firebase from 'firebase/compat/app';
import { UserAccountService } from '@ztarmobile/zwp-service-backend';
import { ToastrHelperService } from 'src/services/toast-helper.service';
import { PlatformLocation } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { AppState } from '@app/app.service';
import { CAPTCHA_BOT_ERROR_CODE } from '@app/app.config';
import { ModalHelperService } from '@services/modal-helper.service';

export class ActivatedNumberModalContext {
  public customClass?: string;
  public label?: string;
  public title?: string;
}

@Component({
  selector: 'app-add-activated-number-modal',
  templateUrl: './add-activated-number-modal.component.html'
})
export class AddActivatedNumberModalComponent implements OnDestroy {
  public context: any;
  public phoneNumber: string;
  public verificationCode: string;
  public recaptchaResponse: any;
  public waitingConfirmCode = false;
  public processingRequest = false;
  public processingMdnRequest = false;
  public recaptchaResolvedSubscription: Subscription;
  
  private verificationId: string;
  private recaptchaVerifier: firebase.auth.RecaptchaVerifier;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialogRef<ActivatedNumberModalContext>,
    private toastHelper: ToastrHelperService,
    private userAccountService: UserAccountService,
    private location: PlatformLocation, private appState: AppState,
  private modalHelper: ModalHelperService) {
    this.context = data;
    location.onPopState(() => { this.beforeDismiss(); this.dialog.close(); });
  }

  ngOnDestroy(): void {
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }
  beforeClose(): boolean {
    if (document.body.classList.contains('modal-open')) {
      document.body.classList.remove('modal-open');
    }
    return false;
  }

  beforeDismiss(): boolean {
    return this.beforeClose();
  }

  cancel(): void {
    this.beforeDismiss();
    this.dialog.close();
  }

  public sendCode(): void {
    const action = 'gm_validate_mdn';
    this.appState.resetAndExecuteCaptchaSubject.next({action});
    if (!!this.phoneNumber && this.phoneNumber?.length > 8) {
      this.appState.loading = true;
      this.processingMdnRequest = true;
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
      this.recaptchaResponse = response;
      if(!!this.recaptchaResponse) {
        this.recaptchaResolvedSubscription?.unsubscribe();
        this.callIsValidPhoneNumber(this.recaptchaResponse, true, action);
      }
     });
    } else {
      this.toastHelper.showAlert('Please enter valid phone number');
    }
  }
  public callIsValidPhoneNumber(captchaRes, invisibleCaptchaRes, action?): void {
    this.userAccountService.isValidPhoneNumber(this.phoneNumber, captchaRes, !!action?action:null, invisibleCaptchaRes).then(() => {
      this.sendVerificationCode();
    }, (error) => {
      this.processingMdnRequest = false;
      this.appState.loading = false;
      if(error?.code === CAPTCHA_BOT_ERROR_CODE) {
        this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result)=>{
          if(!!result) {
            this.appState.loading = true;
            this.callIsValidPhoneNumber(result,false);
          }
        })
       } else {
        this.toastHelper.showAlert(error.message);
       }
      this.recaptchaResolvedSubscription?.unsubscribe();
    });
  }
  public verifyLoginCode(): void {
    this.processingRequest = true;
    if (this.verificationCode === '999999') {
      console.log('pass verification code');
    }
    const cred = firebase.auth.PhoneAuthProvider.credential(this.verificationId, this.verificationCode);
    firebase.auth().currentUser.updatePhoneNumber(cred).then(() => {
      this.processingRequest = false;
      this.dialog.close(this.phoneNumber);
    }).catch((error) => {
      this.processingRequest = false;
      this.toastHelper.showAlert(error.message);
    });
  }

  private sendVerificationCode(): void {
    const provider = new firebase.auth.PhoneAuthProvider();
    provider.verifyPhoneNumber(`+1${this.phoneNumber}`, this.recaptchaVerifier).then((result) => {
      this.verificationId = result;
      this.waitingConfirmCode = !!result;
      this.processingMdnRequest = false;
    }).catch((error) => {
      this.processingMdnRequest = false;
      this.toastHelper.showAlert(error.message);
    });
  }
}

